export const STAGES = [
  "New",
  "Market Qualified Lead (MQL)",
  "Sales Qualified Lead (SQL)",
  "Junk",
  "Not connected",
  "Followup/Connect later",
  "Requirement Gathering(RFI)",
  "Solutioning / Proposal Preparation",
  "Proposal Submission",
  "Negotiation",
  "Agreement Signing",
  "Won",
  "Onboarding",
  "Live",
  "On Hold",
  "Lost",
];

// No stage currently forces a Hot/Warm/Cold/Lost tag on transition — kept in sync
// with backend/business_rules.py STAGE_DEFAULTS (all tagging_required: false).
export const STAGES_REQUIRING_TAG = new Set([]);

export const TAGS = ["Hot", "Warm", "Cold", "Lost", "Deal Closed"];

// Every stage's fixed tag, per the LMSW stage table. The backend auto-assigns this
// on transition (see business_rules.STAGE_TAG_MAP) — only a super_admin can override
// it in the UI. Kept here purely to preview/pre-fill the tag in the move-stage dialog.
export const STAGE_TAG_MAP = {
  "Market Qualified Lead (MQL)": "Warm",
  "Sales Qualified Lead (SQL)": "Warm",
  "Junk": "Cold",
  "Not connected": "Warm",
  "Followup/Connect later": "Warm",
  "Requirement Gathering(RFI)": "Warm",
  "Solutioning / Proposal Preparation": "Warm",
  "Proposal Submission": "Hot",
  "Negotiation": "Hot",
  "Agreement Signing": "Hot",
  "Won": "Deal Closed",
  "Onboarding": "Deal Closed",
  "Live": "Deal Closed",
  "On Hold": "Cold",
  "Lost": "Cold",
};

// Metadata for every mandatory field that can be requested during a stage transition.
// `type` drives the inline editor in StageTransitionDialog.
export const FIELD_META = {
  lead_source: { label: "Lead Source", type: "master", masterKey: "lead_source" },
  sales_poc: { label: "Pipeline", type: "master", masterKey: "sales_poc" },
  company_name: { label: "Company Name", type: "text" },
  website_url: { label: "Website URL", type: "text", placeholder: "https://" },
  client_poc_name: { label: "Client POC Name", type: "text" },
  poc_designation: { label: "POC Designation", type: "text" },
  category: { label: "Category", type: "master", masterKey: "category" },
  client_type: { label: "Client Type", type: "master", masterKey: "client_type" },
  remarks: { label: "Remarks", type: "textarea" },
  opportunity_type: { label: "Opportunity Type", type: "multimaster", masterKey: "opp_type" },
  warehouse_location: { label: "Warehouse Location", type: "text" },
  hq_city: { label: "HQ City", type: "text" },
  hq_state: { label: "HQ State", type: "master", masterKey: "state" },
  current_wh_partner: { label: "Current WH Partner", type: "master", masterKey: "wh_partner" },
  current_lm_partner: { label: "Current LM Partner", type: "master", masterKey: "lm_partner" },
  wms_oms: { label: "WMS/OMS", type: "master", masterKey: "wms_oms" },
  monthly_order_potential: { label: "Monthly Order Potential", type: "number" },
  overall_monthly_revenue: { label: "Overall Monthly Revenue (Potential)", type: "number" },
  universal_order_potential: { label: "Universal Order Potential (B2C & D2C)", type: "number" },
  mg_amount: { label: "MG Amount", type: "number" },
  interested_month: { label: "Interested Month", type: "month" },
  tentative_live_month: { label: "Tentative Live Month", type: "month" },
  agreement_initiated_month: { label: "Agreement Initiated Month", type: "month" },
  oib_month: { label: "OIB Month", type: "month" },
  live_month: { label: "Live Month", type: "month" },
  closure_month: { label: "Closure Month", type: "month" },
  expected_revenue: { label: "Expected Revenue (₹)", type: "number" },
  actual_signed_date: { label: "Actual Date of Signed", type: "date" },
  client_head_office: { label: "Head Office of Client", type: "text" },
  business_model: { label: "Business Model", type: "master", masterKey: "business_model" },
  service_interested: { label: "Service Interested", type: "text" },
  fc_location: { label: "FC Location", type: "text" },
  lost_reason: { label: "Lost / Not Int Reason", type: "master", masterKey: "lost_reason" },
};
